// =============================================================================
// ELEFA CONNECT - MARKETING CONFIGURATION (Single Source of Truth)
// =============================================================================

export const MARKETING_CONFIG = {
  customerCount: "Growing",
  starRating: "4.8",
  reviewCount: "",
  savingsVsCarriers: "40%+",
  esimActivationMinutes: 5,
  activationTimeDisplay: "5-min eSIM activation",
  networkProvider: "Telstra Wholesale Mobile Network",
  networkType: "4G/5G (capped speeds apply)",
  networkDescription: "Australia-wide coverage",
  networkCoverageDescription: "Reliable network coverage",
  maxSpeedMbps: 2000,
  africaCountries: 54,
  internationalCountries: 0, // deprecated - use "every country worldwide"
  voipSavingsPercent: 70,
  connectMinPurchaseForBonus: 25,
  connectTagline: "Call any phone in 195 countries. Encrypted in transit. Purchased credit never expires.",
  connectTaglineShort: "Any phone. 195 countries. No expiry on purchased credit.",
  lowestInternationalRate: "$0.05",
  africaCallingRate: "$0.18",
  southSudanRate: "$0.65",
  ethiopiaRate: "$0.39",
  nigeriaRate: "$0.18",
  // Aligned with spec §2 (WEBSITE_redesign_SPEC_for_lovable.md):
  // "referral A$7.21 each" — matches the native app and public site copy.
  referralBonusReferrer: 721,  // cents (A$7.21)
  referralBonusReferred: 721,  // cents (A$7.21)
  bundleSavingsMax: "$15",
  compliance: {
    tcpCode: "ACMA TCP Code",
    regulatorBody: "ACMA",
  },
  headquarters: "Melbourne, Australia",
  contact: {
    phone: "+61 450 294 281",
    phoneRaw: "+61450294281",
    phoneInternational: "+61 450 294 281",
  },

  company: {
    legalName: "ELEFA MOBILE PTY LTD",
    tradingName: "elefa",
    acn: "694 346 088",
    abn: "16 694 346 088",
    abnUnspaced: "16694346088",
  },
  mvno: {
    descriptor: "Australian MVNO",
    networkPartner: "Host MNO Network",
    voipProduct: "OTT VoIP Application",
    iddService: "IDD (International Direct Dialling)",
    mvnePartner: "MVNE Partner (TelcoInABox)",
  },
  SHOW_WAITLIST_COUNT: false,
  appStore: {
    // Both apps are publicly listed and verified live (2026-07-30).
    iosUrl: "https://apps.apple.com/app/id6766495445",
    iosLive: true,
    androidUrl:
      "https://play.google.com/store/apps/details?id=tel.elefa.connect&referrer=utm_source%3Delefa.tel%26utm_medium%3Dweb%26utm_campaign%3Dlaunch",
    androidLive: true,
  },
} as const;

export const getFormattedRating = () => `${MARKETING_CONFIG.starRating}/5 Rating`;
export const getCustomerCountDisplay = () => `${MARKETING_CONFIG.customerCount} Community`;
export const getSavingsDisplay = () => `Save ${MARKETING_CONFIG.savingsVsCarriers} vs Major Carriers`;
export const getCoverageDisplay = () => MARKETING_CONFIG.networkCoverageDescription;
export const getAfricaCountriesDisplay = () => `${MARKETING_CONFIG.africaCountries}+ African countries`;
export const getInternationalCountriesDisplay = () => `every country worldwide`;
export const getReferralDisplay = () => `$${MARKETING_CONFIG.referralBonusReferrer} Referral Bonus`;
export const getActivationDisplay = () => `Activate in ${MARKETING_CONFIG.esimActivationMinutes} mins`;
export const getNetworkDisplay = () => `${MARKETING_CONFIG.networkDescription}`;
export const getVoipSavingsDisplay = () => `up to ${MARKETING_CONFIG.voipSavingsPercent}% cheaper`;
